// src/belediye/components/notifications/resolveNotificationTarget.js
// FAZ-47 — Bildirim yönlendirmesinin TEK kaynağı.
//
// Öncesinde üç bileşen üç farklı mantık kullanıyordu:
//   • Zil (NotificationsBell): conversation_id → task_id → application_id
//     (backend'in ürettiği target_url'i hiç okumuyordu)
//   • Toaster: target_url → application_id
//   • "Tümü" sayfası (NotificationsPage): YALNIZ application_id — bu yüzden görev
//     bildirimine tıklayınca okundu oluyor ama hiçbir yere GİTMİYORDU.
//
// Artık üçü de burayı çağırır. Yeni bir bildirim türü eklendiğinde tek yer değişir.
//
// Dönüş: { kind: "chat", conversationId } | { kind: "route", path } | null
// "chat" yalnız sohbet köprüsü olan yerlerde (zil/toaster) anlamlıdır; sayfa
// tarafı chatFallbackPath ile rotaya çevirebilir.

const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

const posInt = (v) => {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : null;
};

/** Bildirim payload'ının farklı sarmalarında aynı alanı arar. */
const pick = (n, key) =>
  posInt(
    n?.[key] ??
      n?.inapp_payload?.[key] ??
      n?.payload?.[key] ??
      n?.inapp_payload?.payload?.[key] ??
      null
  );

export const pickConversationId = (n) => pick(n, "conversation_id");
export const pickTaskId = (n) => pick(n, "task_id");
export const pickApplicationId = (n) => pick(n, "application_id");

/**
 * @param {object} n  bildirim satırı
 * @param {object} [opts]
 * @param {boolean} [opts.allowChat=true]  sohbet köprüsü kullanılabilir mi
 */
export default function resolveNotificationTarget(n, opts = {}) {
  const { allowChat = true } = opts;
  if (!n) return null;

  // 1) Sohbet bildirimi — dock'ta yerinde açılır (rota değişmez).
  const convId = pickConversationId(n);
  if (convId && allowChat) return { kind: "chat", conversationId: convId };

  // 2) Backend'in ürettiği hedef (görev/duyuru/başvuru — üretici ne derse).
  const url = safeStr(n?.target_url).trim();
  if (url.startsWith("/")) return { kind: "route", path: url };

  // 3) target_url yoksa taşıyıcı alanlardan türet (eski satırlar için).
  const taskId = pickTaskId(n);
  if (taskId) return { kind: "route", path: `/yonetim/gorevler/${taskId}` };
  // FAZ-52: sohbet rotası KALDIRILDI — "Mesajlar" sayfası silindi, mesajlaşmanın
  // tek yüzeyi dock. Sohbet bildirimi allowChat:false ile çözülüyorsa gidilecek
  // bir yer yoktur (bugün tüm çağıranlar allowChat:true kullanıyor).
  const appId = pickApplicationId(n);
  if (appId) return { kind: "route", path: `/yonetim/basvurular/${appId}` };

  return null;
}
